export default "__VITE_ASSET__03bee380__"